import React from 'react';
import SchoolList from './SchoolList';
import schbanner from './img/schools/banner.jpg';
import mdulogo from './img/schools/mdulogo.png';
import jk from './img/schools/jk.jpg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const schools = [
    {
        "img": require('./img/schools/sjc.jpg'),
        "title": "St Joseph's College Hr Sec School",
        "place": "Tiruchirapalli",
        "website":"https://www.sjctni.edu"
    },
    {
        "img": require('./img/schools/mdu stmarys.jpg'),
        "title": "St Mary's Hr. Sec. School",
        "place": "Madurai",
        "website":"https://stmaryshssmdu.in/"
    },
    {
        "img": require('./img/schools/dgl stmarys.jpg'),
        "title": "St Mary's Hr. Sec. School",
        "place": "Dindigul",
        "website":"https://stmarysdindigul.org/"
    },
    {
        "img": require('./img/schools/stxaviers.jpg'),
        "title": "St Xavier's Hr. Sec. School",
        "place": "Palayamkottai",
        "website":"https://www.stxaviershsspalay.com/"
    },
    {
        "img": require('./img/schools/debritto.jpg'),
        "title": "De Britto Hr. Sec. School",
        "place": "Devakottai",
        "website":"https://www.debrittohssdvk.org/"
    },
    {
        "img": require('./img/schools/oriyur.jpg'),
        "title": "St Arulanandar Hr. Sec. School",
        "place": "Oriyur",
        "website":"https://www.starulanandarhssoriyur.com/"
    },
    {
        "img": require('./img/schools/sxs thothukudi.jpg'),
        "title": "St Xavier's Hr. Sec. School",
        "place": "Thoothukudi",
        "website":"https://stxaviersthoothukudi.com/"
    },
    {
        "img": require('./img/schools/carmel.jpg'),
        "title": "Carmel Hr. Sec. School",
        "place": "Nagercoil",
        "website":"/"
    },
    {
        "img": require('./img/schools/loyolatech.jpg'),
        "title": "Loyola Tech School",
        "place": "Dindigul",
        "website":"https://loyolatechschool.com/"
    }
    ,
    ,
    {
        "img": require('./img/schools/ignatius.jpeg'),
        "title": "St. Mary's Tope Middle School",
        "place": "Trichy",
        "website":"/"
    },{
        "img": require('./img/schools/ignatius.jpeg'),
        "title": "St.Arulanandar Primary School",
        "place": "Oriyur",
        "website":"/"
    },
    {
        "img": require('./img/schools/ignatius.jpeg'),
        "title": "RC Middle School",
        "place": "Ariyamangalam, Trichy",
        "website":"/"
    },
    {
        "img": require('./img/schools/ignatius.jpeg'),
        "title": "RC Primary School",
        "place": "Palamalai, Kodaikanal",
        "website":"/"
    },
    {
        "img": require('./img/schools/ignatius.jpeg'),
        "title": "Gandhi Primary School",
        "place": "Pallangi, Kodaikanal",
        "website":"/"
    },
    {
        "img": require('./img/schools/ignatius.jpeg'),
        "title": "Nethaji Primary School",
        "place": "Puthuputhur, Kodaikanal",
        "website":"/"
    }
]

export default function SchoolMain() {
  return (
    <div>
      <img style={{paddingBottom:"2%"}} className='img-fluid' src={schbanner} alt='' />
    <Row className='p-3'>
      <Col md={6}>
      <h1>MADURAI <br/> 
      <img style={{paddingBottom:"2%"}} className='img-fluid' src={mdulogo} alt='' /> <br/>Jesuit Province</h1>
      </Col>
      <Col md={6}>
      {schools.map((item,index)=>{return(

     <div style={{textAlign:"left", padding:"5px"}}>
     <h5> {index+1}. {item.title}, {item.place}
      </h5>
     </div>
     
       
        )})}
      </Col>
    </Row>
      <SchoolList />
      <div className=' bg-gradient-school'>
        <div className='container'>
          <Row className='p-3'>
      <Col md={3}>
      
      <img style={{paddingBottom:"2%", width:"200px"}} className='img-fluid rounded' src={jk} alt='' /> <br/>
      <h5>
        Rev. Dr. John Kennedy SJ, School Education, Co-ordinator
      </h5>
      </Col>
      <Col md={9}>
      

     <div style={{textAlign:"center", padding:"5px"}}>
     <h4 style={{lineHeight:"50px"}}> 
         “He learned by experience that one train of thought left him sad, <br/>
         the other joyful. This was his first reasoning on spiritual matters.” <br/>
                                                  ― Ignatius of Loyola,
      </h4>
     </div>
     
       
      
      </Col>
</Row>
        </div>
        
      </div>
</div>
  )
}
